/**
 * Sparrow Forge — top-level React component.
 *
 * v140 architecture: the App is a router-light shell. The /pages/the-forge
 * embed uses this entrypoint; the /pages/wind-drift standalone page uses
 * src/wind-drift/main.tsx as a separate entry.
 *
 * For now this is a stub. Real component graph is staged for v140 PR work
 * and will replace this file as the PRs land. See docs/v140-implementation-spec.md.
 */
export function App() {
  return (
    <div className="forge-root">
      <header>
        <h1>Sparrow Forge</h1>
        <p>v140 bootstrap — real component graph staged for PR work.</p>
      </header>
      <main>
        <p>
          See <a href="/wind-drift.html">/pages/wind-drift</a> for the
          3D wind-drift visualizer (v140 PR 5).
        </p>
      </main>
    </div>
  );
}
